// Map is keyed by `"<METHOD> <url>"`. See setupMockInterceptors.js.
export const API_MOCKS = {};
